import React from "react";
import moment from "moment";
import AttachmentModal from "../Components/widgets/AttachmentModal";

// Laporan masalah dari user (tombol "Support" di web app), status diupdate
// manual oleh admin di sini. Data dari tabel support_reports lewat generic
// CRUD engine backend (/crud/support_reports).
const STATUS_LABELS = ["Open", "Work-in-progress", "Done"];

let supportReportsSection = {
  name: "Laporan Masalah",
  slug: "supportReports",
  visible: true,
  singularName: "Laporan",
  crud: true,
  endpoint: "/crud/support_reports",
  updateLabel: "description",
  filters: [],
  meta: {
    delete_flag: true,
  },
  access: ["superadmin"],
  delete: true,
  add: false,
  update: true,
  // Status diubah langsung lewat dropdown inline di tabel (lihat field "Status"
  // editable di bawah), jadi layar edit detail tidak diperlukan.
  edit: false,
  actions: [
    {
      // Tombol "Balas" per baris -> membuka halaman SupportReply
      // (slug: supportReply) dengan membawa data laporan lewat location.state.
      name: "reply",
      icon: "i-Speach-Bubble-3",
      label: "Balas",
      tooltip: "Balas laporan",
      uri: () => "/dashboard/supportReply",
      onPush: (rowData) => rowData,
      redirect: true,
    },
  ],
  fields: [
    {
      label: "Timestamp",
      input: false,
      resource_label: (row) => {
        if (!row) return "-";
        return moment(row.created_at).tz("Asia/Jakarta").format("DD MMM YYYY HH:mm");
      },
    },
    {
      label: "Username",
      name: "username",
      type: "text",
      input: false,
      resource_label: (row) => (row && row.username ? row.username : "-"),
    },
    {
      label: "Kategori",
      name: "platform",
      type: "text",
      input: false,
      resource_label: (row) => (row && row.platform ? row.platform : "-"),
    },
    {
      label: "Deskripsi",
      name: "description",
      type: "text",
      input: false,
    },
    {
      label: "Lampiran",
      input: false,
      resource_label: (row) => {
        if (!row || !row.attachment_url) return "-";
        // Popup preview + tombol Download.
        return <AttachmentModal url={row.attachment_url} />;
      },
    },
    {
      label: "Status",
      name: "status",
      type: "lookup",
      // editable: dropdown pilihan langsung di baris tabel, tersimpan otomatis
      // saat diganti (via onSwitch -> crudUpdateAction).
      editable: true,
      values: [
        { value: 0, text: "Open" },
        { value: 1, text: "Work-in-progress" },
        { value: 2, text: "Done" },
      ],
      resource_label: (row) => {
        if (!row) return "";
        return STATUS_LABELS[row.status] || "Open";
      },
      defaultValue: (row) => (row ? row.status : 0),
    },
  ],
};

export default [supportReportsSection];
